(function () {
  function closeFiltersOutside(event) {
    const openFilters = document.querySelectorAll(
      '.facets__disclosure[open]'
    );

    if (!openFilters.length) return;

    openFilters.forEach(function (filter) {
      if (!filter.contains(event.target)) {
        setTimeout(function () {
          filter.removeAttribute('open');
        }, 0);
      }
    });
  }

  document.addEventListener(
    'click',
    closeFiltersOutside,
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    document
      .querySelectorAll('.facets__disclosure[open]')
      .forEach(function (filter) {
        filter.removeAttribute('open');
      });
  });
})();